import {
  Button,
  Footer,
  Header,
  InvoiceFormPreview,
  QuoteForm,
} from "../../components";
import { HeaderType } from "../../components/Header/Header";
import { QuoteStyle } from "./Quote.style";
import { Section } from "../../components/common";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { useState } from "react";
import { ButtonType } from "../../components/common/Button/Button";
import axios from "axios";
import { message } from "antd";
import FinalStep from "../../components/QuotationForm/Steps/FinalStep";
import { format } from "date-fns";

const Quote = () => {
  const methods = useForm({
    defaultValues: {
      vehicles: [
        {
          vehicleYear: "",
          vehicleMake: "",
          vehicleModel: "",
          quantity: 0,
          price: 0,
          etaForDropOff: "",
        },
      ],
    },
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [vehiclesTotalPrice, setVehiclesTotalPrice] = useState(0);
  const [isPreviewMode] = useState(false);

  const {
    handleSubmit,
    formState: { isDirty, isValid },
    reset,
  } = methods;

  const handleFormSubmit = async (data: FieldValues) => {
    try {
      const values: FieldValues = { ...data };

      const formattedPickUpDate = values.pickUpDate
        ? format(new Date(values.pickUpDate), "MM/dd/yyyy")
        : "";

      // ✅ FIX: Updated URL to use quote.php (correct spelling)
      // Changed from: `/php/qoute.php?${params.toString()}`
      // Changed to: Direct axios POST with JSON body (better practice)
      const invoiceData = {
        representativeEmail: values.representativeEmail || "",
        representativeName: values.representativeName || "",
        representativePhone: values.representativePhone || "",
        billToName: values.billToName || "",
        billToPhone: values.billToPhone || "",
        billToEmail: values.billToEmail || "",
        billFromName: values.billFromName || "",
        billFromPhone: values.billFromPhone || "",
        pickUpDate: formattedPickUpDate,
        etaForPickup: values.etaForPickup || "",
        pickupFrom: values.pickupFrom || "",
        deliveryTo: values.deliveryTo || "",
        totalAmount: String(vehiclesTotalPrice || 0),
        deposit: values.deposit || "",
        balance: values.balance || "",
        vehicles: values.vehicles || [],
        pickupFullAddress: values.pickupFullAddress || "",
        dropOffFullAddress: values.dropOffFullAddress || "",
        dropOffPersonPhone: values.dropOffPersonPhone || "",
        dropOffPersonName: values.dropOffPersonName || "",
        dropOffPersonEmail: values.dropOffPersonEmail || "",
        etaForDropOff: values.etaForDropOff || "",
      };

      // ✅ Send as JSON POST body instead of URL parameters
      await axios.post("/php/quote.php", invoiceData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      message.success("Email sent successfully");
      setIsSubmitted(true);
      reset();
    } catch (error) {
      console.error("Quote email error:", error);
      message.error("Email sending failed. Please try again.");
    }
  };

  return (
    <QuoteStyle>
      <Header
        heading="Invoice"
        image="/images/banners/terms-and-conditions.png"
        type={HeaderType.inner}
      />

      <Section>
        {isSubmitted ? (
          <div className="final-step">
            <FinalStep />
            <Button label="Go Back" onClick={() => setIsSubmitted(false)} />
          </div>
        ) : (
          <FormProvider {...methods}>
            <section className="quote-wrapper">
              <form
                className="quote-form"
                onSubmit={handleSubmit(handleFormSubmit)}
              >
                <article className="fields-container">
                  <QuoteForm
                    vehiclesTotalPrice={vehiclesTotalPrice}
                    setVehiclesTotalPrice={setVehiclesTotalPrice}
                  />
                </article>

                <article
                  className={`fields-wrapper form-footer ${
                    isPreviewMode && "center"
                  }`}
                >
                  <Button
                    type={ButtonType.filled}
                    label="Send Email"
                    disabled={!isDirty || !isValid}
                  />
                </article>
              </form>

              <InvoiceFormPreview vehiclesTotalPrice={vehiclesTotalPrice} />
            </section>
          </FormProvider>
        )}
      </Section>

      <Footer />
    </QuoteStyle>
  );
};

export default Quote;
